import { useEffect, useState } from "react";
import SectionPage from "./pages/SectionPage";
import { Provider } from "react-redux";
import { initTracking } from "./services/tracking";
import moment from "moment";
import store from "./store";
import "moment/locale/he";

moment.locale("he");

function App() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    window.parent.location = "https://www.ynet.co.il/games";

    // const parentUrl =
    //   window.location != window.parent.location
    //     ? document.referrer
    //     : document.location.href;

    // const getUrlParams = () => {
    //   let search = window.location.search;
    //   let params = new URLSearchParams(search);

    //   return {
    //     sectionId: params.get("sectionId"),
    //     publishKey: params.get("publishKey"),
    //     gaTrackingId: params.get("gaTrackingId"),
    //     // path: `https://www.ynet.co.il/news/article/${params.get("basePath")}`,
    //     path: `http://localhost:3000`,
    //     pathCategory: `https://www.ynet.co.il/category`,
    //     gi: params.get("gi"),
    //   };
    // };

    // const _config = getUrlParams();

    // init(_config);
  }, []);

  // const init = (_config) => {
  //   initTracking(_config.gaTrackingId, "ynet");

  //   // if (_config.publishKey !== "pk_test_TYooMiaQauvdEDq54NiTphIlucia7jx") {
  //   //   console.error(
  //   //     `<< 🧩 JOGO SDK 🧩 >> Error: publish key is not valid for section ->`,
  //   //     _config.sectionId
  //   //   );
  //   //   return;
  //   // }

  //   setConfig(_config);
  // };

  // if (!config || !config.sectionId) return <></>;

  return <></>;
}

export default App;
